<template>
  <div class="class_box">
    <template>
      <div class="c_item_box" v-for="(value,key,index) in dataList" :key="'aud_'+index">
        <h3 class="c_i_title">{{key}}</h3>
        <div class="c_con_box">
          <div class="c_c_box" v-for="(item,ind) in value" :key="'aud_i_'+ind" @click="routerPush(item)">
            <div class="v_b_img">
              <el-image class="b_img" fit="cover" :src="item.cover?require('@/assets/img/audit/'+item.cover+'.png'):''"></el-image>
            </div>
            <p class="v_b_title"><span>{{item.gradeName}}{{item.subjectName}}</span><span class="b_size">{{item.count}}</span></p>
          </div>
        </div>
      </div>
      <div class="unusual" style="padding-bottom:30px" v-if="Object.keys(dataList).length<=0"><span class="pt320">暂无内容</span></div>
    </template>

  </div>
</template>

<script>
export default {
  data() {
    return {
      dataList: [],
    };
  },
  methods: {
    getData() {
      this.$ajax.post("/server/third/resource/approval/init").then((res) => {
        let data = res.data;
        for (const val in data) {
          data[val].forEach((item) => {
            item.cover = this.getCover(item.subjectName);
          });
        }
        this.dataList = data;
      });
    },
    routerPush(data) {
      this.$router.push({
        name: "auditClassExamine",
        params: { parData: data },
      });
    },
    getCover(subjectName) {
      let val = "";
      switch (subjectName) {
        case "语文":
          val = "yw";
          break;
        case "数学":
          val = "sx";
          break;
        case "英语":
          val = "yy";
          break;
        case "物理":
          val = "wl";
          break;
        case "化学":
          val = "hx";
          break;
        case "生物":
          val = "sw";
          break;
        case "地理":
          val = "dl";
          break;
        case "历史":
          val = "ls";
          break;
        case "政治":
          val = "zz";
          break;
        case "道德与法制":
          val = "ddyfz";
          break;
        default:
          break;
      }
      return val;
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped>
.class_box {
  background-color: #fff;
  padding: 0 15px;
  overflow: hidden;
}
.c_item_box {
}
.c_i_title {
  line-height: 50px;
  font-size: 16px;
  color: #333;
}
.c_con_box {
  display: flex;
  flex-wrap: wrap;
}
.c_c_box {
  width: 210px;
  height: 186px;
  padding: 20px 20px 10px;
  box-sizing: border-box;
  box-shadow: 0 0 5px 1px #f1f1f1;
  margin-bottom: 20px;
  margin-right: 30px;
  cursor: pointer;
}
.c_c_box:nth-child(5n) {
  margin-right: 0;
}
.v_b_img {
  width: 100%;
  height: 120px;
  margin: 0 auto;
  position: relative;
}
.b_img {
  width: 100%;
  height: 100%;
}
.v_b_title {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  margin-top: 5px;
  line-height: 30px;
  color: #000;
}
.b_size {
  color: #409eff;
}
.v_b_time {
  font-size: 12px;
  color: #999;
}
.v_b_menu {
  display: flex;
  justify-content: space-around;
  font-size: 12px;
  color: #333;
  margin-top: 10px;
}
.b_m_p {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}
.m_p_icon {
  font-size: 20px;
}
</style>


// WEBPACK FOOTER //
// src/page/audit/classroomAudit.vue